module.exports = __webpack_public_path__ + "static/about-image-59bd5c2213640e5ca5b7817cf6cae3a1.jpg";